import { locale } from '@trqk/utils';

export const getPlanDisplayName = (
    displayName: string | null | undefined,
    planId?: Maybe<ChargebeePlanId>,
): string => {
    if (displayName) {
        return displayName;
    }

    if (planId) {
        return locale.enUS.ACCOUNT.SECTIONS.PAYMENT_PLAN.PLAN_DISPLAY_NAMES[
            planId
        ];
    }

    return locale.enUS.ACCOUNT.SECTIONS.PAYMENT_PLAN.YOUR_PLAN;
};
